import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Plan() {
  return (
    <>
      <div className="container-fluid plan-container px-0">
        <HelmetProvider>
          <Helmet>
            <title>Gym Listing & Software Plans | MeraGym</title>
            <meta
              name="keywords"
              content="gym listing plan, gym software plan, meragym plans, gym management pricing, free gym listing, gym software pricing India"
            />
            <meta
              name="description"
              content="Choose the right MeraGym plan for your gym or fitness center. List your gym for free or upgrade to our advanced gym management software. Transparent pricing, no hidden fees."
            />
            <link rel="canonical" href="https://meragym.com/plans" />
            <meta property="og:title" content="Gym Listing & Software Plans | MeraGym" />
            <meta property="og:description" content="List your gym for free or get advanced gym management software. Choose the plan that fits your fitness business." />
            <meta property="og:url" content="https://meragym.com/plans" />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Gym Listing & Software Plans | MeraGym" />
            <meta name="twitter:description" content="Free and premium plans for gyms on MeraGym. Grow your fitness business today." />
          </Helmet>
        </HelmetProvider>
        <section className="plan-intro-section">
          <div className="container">
            <div className="text-center">
              <h1 className="text-white">
                Choose Your <span className="text-danger">Plan</span>
              </h1>
              <h2 className="text-white" style={{ fontSize: "1.1rem", fontWeight: 400 }}>
                Join MeraGym — choose between four ways to grow your fitness business
              </h2>
            </div>
          </div>
        </section>
        <section className="plan-section">
          <div className="container">
            {/* switch tab for mobile */}
            <div className="plan-responsive-mobile">
              <ul className="nav border-0">
                <li className="nav-item">
                  <a
                    href="#basic"
                    className="nav-link active"
                    data-bs-toggle="tab"
                  >
                    Basic
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#starter" className="nav-link" data-bs-toggle="tab">
                    Starter
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#business" className="nav-link" data-bs-toggle="tab">
                    Business
                  </a>
                </li>
                <li className="nav-item">
                  <a href="#premium" className="nav-link" data-bs-toggle="tab">
                    Premium
                  </a>
                </li>
              </ul>
            </div>
            {/*End of mobole switch tab */}
            <div className="row tab-content">
              <div className="col-lg-3 col-md-6 tab-pane active" id="basic">
                <div className="card">
                  <div className="card-header plan-card1">
                    <h4>
                      <i className="bi bi-box me-2"></i>
                      <span>Free Plan (Starter)</span>
                    </h4>
                  </div>
                  <div className="card-body">
                    <h2>
                      Free<sub>/3 Days</sub>
                    </h2>
                    <ul className="plan-list1">
                      <li>
                        <span>Basic gym management tool</span>
                      </li>
                      <li>
                        <span>Member management (Limited 50 Members)</span>
                      </li>
                      <li>
                        <span>Payment management</span>
                      </li>
                      <li>
                        <span>Attandance tracking</span>
                      </li>
                      <li>
                        <span>Reporting & analysis</span>
                      </li>
                      <li>
                        <span>Technical & training support</span>
                      </li>
                    </ul>
                    <hr></hr>
                    <h6>
                      Ideal for smart gyms & startup looking for a cost
                      effective solution to manage their operations
                    </h6>
                  </div>
                  <div className="card-footer">
                    <a href="https://wa.me/916390008506?text=Hi, I'm interested in the Free Plan (Starter)" target="_blank" rel="noreferrer" className="plan-btn1">
                      Contact Us<i className="bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 tab-pane" id="starter">
                <div className="card">
                  <div className="card-header plan-card2">
                    <h4>
                      <i className="bi bi-send me-2"></i>
                      <span>Premium Plan (3 Month)</span>
                    </h4>
                  </div>
                  <div className="card-body">
                    {/* <h2>
                      <i className="bi bi-currency-rupee"></i>
                      <span>15,000</span>{" "}
                      <span className="ovr-txt">25,000</span>
                      <sub>/Year</sub>
                    </h2> */}
                    <h2>
                      <span>Request for a quote</span>
                    </h2>
                    <ul className="plan-list2">
                      <li>
                        <span>All Features From The Free Plan</span>
                      </li>
                      <li>
                        <span>Unlimited member management capacity</span>
                      </li>
                      <li>
                        <span>Advanced reporting & analytics</span>
                      </li>
                      <li>
                        <span>Attendance report & analysis</span>
                      </li>
                      <li>
                        <span>Priority technical & training support</span>
                      </li>
                    </ul>
                    <hr></hr>
                    <h6>
                      Ideal for gyms with single branch that require more robus
                      management tools
                    </h6>
                  </div>
                  <div className="card-footer">
                    <a href="https://wa.me/916390008506?text=Hi, I'm interested in the Premium Plan (3 Month)" target="_blank" rel="noreferrer" className="plan-btn2">
                      Contact Us<i className="bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 tab-pane" id="business">
                <div className="card">
                  <div className="card-header plan-card3">
                    <h4>
                      <i className="bi bi-box-seam me-2"></i>
                      <span>Premium Plan (Annual)</span>
                    </h4>
                  </div>
                  <div className="card-body">
                    {/* <h2>
                      <i className="bi bi-currency-rupee"></i>
                      <span>50,000</span>{" "}
                      <span className="ovr-txt">65,000</span>
                      <sub>/Year</sub>
                    </h2> */}
                    <h2>
                      <span>Request for a quote</span>
                    </h2>
                    <ul className="plan-list3">
                      <li>
                        <span>All features from the free plan</span>
                      </li>
                      <li>
                        <span>Unlimited member management capacity</span>
                      </li>
                      <li>
                        <span>Advanced reporting & analytics</span>
                      </li>
                      <li>
                        <span>Attendance report & analysis</span>
                      </li>
                      <li>
                        <span>Priority technical & training support</span>
                      </li>
                    </ul>
                    <hr></hr>
                    <h6>
                      Ideal for gyms with single branch that require more robust
                      management tools
                    </h6>
                  </div>
                  <div className="card-footer">
                    <a href="https://wa.me/916390008506?text=Hi, I'm interested in the Premium Plan (Annual)" target="_blank" rel="noreferrer" className="plan-btn3">
                      Contact Us<i className="bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 tab-pane" id="premium">
                <div className="card">
                  <div className="card-header plan-card4">
                    <h4>
                      <i className="bi bi-boxes me-2"></i>
                      <span>Enterprise Plan (Customized)</span>
                    </h4>
                  </div>
                  <div className="card-body">
                    <h2>
                      <span>Request for a quote</span>
                    </h2>
                    <ul className="plan-list4">
                      <li>
                        <span>
                          Tailored solutions, including, unique features or
                          integrations
                        </span>
                      </li>
                      <li>
                        <span>Dedicated account manager</span>
                      </li>
                      <li>
                        <span>On-site training and support</span>
                      </li>
                      <li>
                        <span>Scalable infrastructure</span>
                      </li>
                      <li>
                        <span>Data security and compliance features</span>
                      </li>
                    </ul>
                    <hr></hr>
                    <h6>
                      Ideal for large gym chains, franchises, or enterprises
                      with complex needs, seeking a fully customized solution
                      for gym management
                    </h6>
                  </div>
                  <div className="card-footer">
                    <a href="https://wa.me/916390008506?text=Hi, I'm interested in the Enterprise Plan (Customized)" target="_blank" rel="noreferrer" className="plan-btn4">
                      Contact Us<i className="bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
